// extracted by mini-css-extract-plugin
module.exports = {"faqsdiv":"kdUjJ","que_ans":"SetLV","hardhide":"s9cjv","accordion":"_9d8h","que_head":"PQwv2","collapsed":"KNNQR","ans_desc":"wQbAG","more_btn":"VF3SU","needHelp":"DFbEA"};